import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToasterHelper } from '@shared/helpers';
import { CurrentUserService } from '@shared/services';
import { MessageService } from 'primeng/api';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const globalHttpInterceptorFn: HttpInterceptorFn = (request, next) => {
    const messageService = inject(MessageService);
    const currentUserService = inject(CurrentUserService);

    const isFormData = request.body instanceof FormData;

    const clonedRequest = request.clone({
        setHeaders: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            'Cache-Control': 'no-cache',
            'X-User-ID': `${currentUserService.currentUser().id}`,
        },
    });

    return next(clonedRequest).pipe(
        catchError(response => {
            if (response?.status === 403 || response?.status === 412) {
                currentUserService.triggerUnauthorizedError(true);
                return throwError(() => response);
            }

            currentUserService.triggerUnauthorizedError(false);

            if (response?.status === 500) {
                messageService.add(ToasterHelper.error());
                return throwError(() => response);
            }

            if (response?.error?.error === 'NeedUserConfirmationException') {
                return throwError(response);
            }

            const backendError = response?.error?.message || response?.error?.Message || '';

            if (response?.status === 400) {
                messageService.add(
                    ToasterHelper.error(
                        backendError || "We're having trouble processing this request. Please try again soon."
                    )
                );
                return throwError(() => response);
            }

            if (response?.status === 404) {
                messageService.add(ToasterHelper.error(backendError || 'Not Found'));
                return throwError(() => response);
            }

            if (response?.status === 408) {
                messageService.add(ToasterHelper.error('Timeout error'));
                return throwError(() => response);
            }

            if (
                response?.status === 0 &&
                response?.statusText === 'Unknown Error' &&
                response?.error instanceof ProgressEvent &&
                isFormData
            ) {
                messageService.add(ToasterHelper.error(backendError || 'Unknown error'));
                return throwError(() => response);
            }

            messageService.add(ToasterHelper.error(backendError || 'Unknown error'));
            return throwError(() => response);
        })
    );
};
